import "react-international-phone/style.css";
import "react-loading-skeleton/dist/skeleton.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import * as Sentry from "@sentry/react";
import { store } from './stores/store';
import { router } from './router';
import { FeatureFlagsProvider } from './tenant/features/FeatureFlagsProvider';
import { TenantProvider } from './tenant/branding/TenantProvider';
import { Provider } from 'react-redux';
import CommonFullPageLoader from "./common/components/full-page-loader/CommonFullPageLoader";
import { ThemeProvider } from "./theme/ThemeProvider";
import { BusinessAnalytics } from "@xepp/business-analytics-sdk";
import { businessAnalyticsConfig } from "./services/business-analytics/businessAnalyticsConfig";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

if (process.env.REACT_APP_SENTRY_ENV) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    attachStacktrace: true,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https?:\/\/localhost(:\d+)?\//, new RegExp(`^${process.env.REACT_APP_SERVER_URL}`)],
    // Performance Monitoring
    tracesSampleRate:  Number(process.env.SENTRY_TRACES_SAMPLE_RATE) ?? 0, // Be careful with this setting in production - it can generate a lot of data. Consider adjusting it to a lower value in production.
    replaysSessionSampleRate: Number(process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE) ?? 0, // Adjust this value in production to control the percentage of sessions that are recorded for replay. 10% is a good starting point.
    replaysOnErrorSampleRate: Number(process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) ?? 0, // Record a replay for every error, which is useful for debugging. Adjust this in production if you have a high error rate.
    environment: process.env.REACT_APP_SENTRY_ENV,
  });
}

// Delivery disables itself when the endpoint or key is unset, so this is safe unconfigured.
BusinessAnalytics.init(businessAnalyticsConfig);

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <TenantProvider>
      {/* Fetch tenant feature flags once, before login, shared app-wide via context. */}
      <FeatureFlagsProvider>
        <ThemeProvider>
          <ToastContainer />
          {/* translated components suspend until the customer namespace loads */}
          <React.Suspense fallback={<CommonFullPageLoader />}>
            <RouterProvider
              router={router}
              future={{ v7_startTransition: true }}
            />
          </React.Suspense>
          <CommonFullPageLoader />
        </ThemeProvider>
      </FeatureFlagsProvider>
      </TenantProvider>
    </Provider>
  // </React.StrictMode>
);

console.log('ROOT RENDER');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();